module.exports = __webpack_public_path__ + "img/logo_servicio1.e1e175dc.png";